//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Portal from "@material-ui/core/Portal";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import DataSourcesTable from "src/components/loader/data_sources/DataSourcesTable";
import DataSourceEditDialog from "src/components/loader/data_sources/DataSourceEditDialog";
import CloseableDialog from "eai-configurator-ui/components/configuration/dialog/CloseableDialog";
import * as Utils from "eai-configurator-ui/components/Utils";

const DataSourcesDialog = ({ open, handleClose }) => {
  const [alertMessage, setAlertMessage] = React.useState(null);
  const [dataSourcePendingEdit, setDataSourcePendingEdit] = React.useState(
    false
  );
  const [selectedDataSource, setSelectedDataSource] = React.useState(null);
  const [tableRefreshCounter, setTableRefreshCounter] = React.useState(0);

  const handleCloseEditedDataSource = () => {
    setDataSourcePendingEdit(false);
  };

  const handleEditDataSource = (dataSource) => {
    setSelectedDataSource(dataSource);
    setDataSourcePendingEdit(true);
  };

  const handleRemoveDataSource = (dataSource) => {
    Utils.fetchData(
      "loader/dataSource?id=" + dataSource.id,
      {
        method: "delete",
      },
      false,
      false
    )
      .then((response) => {
        handleApplyDataSourceChanges();
      })
      .catch((response) => {
        Utils.getErrorMessage(
          response,
          "Data Source edit failed."
        ).then((message) =>
          setAlertMessage({ success: false, message: message })
        );
        setDataSourcePendingEdit(false);
      });
  };

  const handleAddDataSource = () => {
    setSelectedDataSource(null);
    setDataSourcePendingEdit(true);
  };

  const handleApplyDataSourceChanges = (dataSource) => {
    // Refresh the table which will issue a new fetch and update its contents
    setTableRefreshCounter(tableRefreshCounter + 1);
  };

  return (
    <span>
      <DataSourceEditDialog
        open={dataSourcePendingEdit}
        dataSource={selectedDataSource}
        handleClose={handleCloseEditedDataSource}
        handleSuccess={handleApplyDataSourceChanges}
      />
      {alertMessage && (
        <Portal>
          <Snackbar
            open={alertMessage}
            autoHideDuration={6000}
            onClose={() => setAlertMessage(null)}
          >
            <Alert
              onClose={() => setAlertMessage(null)}
              severity={
                alertMessage && alertMessage.success ? "success" : "error"
              }
            >
              {alertMessage && (alertMessage.message || "Unknown error")}
            </Alert>
          </Snackbar>
        </Portal>
      )}
      <CloseableDialog
        open={open}
        title={"Manage Data Sources"}
        maxWidth="md"
        fullWidth
        handleClose={handleClose}
      >
        <DialogContent dividers>
          <DataSourcesTable
            refreshCounter={tableRefreshCounter}
            setAlertMessage={setAlertMessage}
            handleEditDataSource={handleEditDataSource}
            handleRemoveDataSource={handleRemoveDataSource}
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleAddDataSource}>
            Add Data Source
          </Button>
        </DialogActions>
      </CloseableDialog>
    </span>
  );
};
export default DataSourcesDialog;
